import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-repricing-trend-badge',
  templateUrl: './repricing-trend-badge.component.html',
  styleUrls: ['./repricing-trend-badge.component.scss']
})
export class RepricingTrendBadgeComponent {
  @Input() trendPercentage: number = 0;
  @Input() isMuted: boolean = false;
  @Input() forceShowSign: boolean = true;
}
